import { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import classes from './FeedbackReplyPopup.module.scss'

export const FEEDBACK_REPLY_BADGE = 'B-Gini Geri Bildiriminiz Hakkında'

export interface FeedbackReplyPopupProps {
  title: string
  /** Sunucuda izin listesiyle temizlenmiş HTML (Faz-37 §3); bileşen ayrıca dönüştürmez. */
  html: string
  /** "Tamam", X ve Esc aynı kapanışı tetikler. */
  onClose: () => void
  confirmText?: string
  /** Birden çok dönüş sırayla gösterilirken "1 / 3" bilgisi. */
  position?: { index: number; total: number }
}

/**
 * Admin'in olumsuz geri bildirime dönüşü — bayinin ana sayfada gördüğü popup. Admin önizlemesi de AYNI
 * bileşeni kullanır; bayiye başlık ve içerik dışında hiçbir şey gösterilmez (soru, tarih, statü yok).
 * Görünüm ana sayfadaki SweetAlert popup'larıyla uyumludur.
 */
export default function FeedbackReplyPopup({
  title,
  html,
  onClose,
  confirmText = 'Tamam',
  position,
}: FeedbackReplyPopupProps) {
  const confirmRef = useRef<HTMLButtonElement>(null)
  const onCloseRef = useRef(onClose)
  onCloseRef.current = onClose

  useEffect(() => {
    confirmRef.current?.focus()
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' || event.key === 'Esc') onCloseRef.current()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [])

  // body'ye taşınır: admin önizlemesinde IPModal'ın, ana sayfada yerleşimin katman sırasından etkilenmez.
  return ReactDOM.createPortal(
    <div className={classes.backdrop} data-testid='feedback-reply-popup'>
      <div className={classes.popup} role='dialog' aria-modal='true' aria-labelledby='feedback-reply-popup-title'>
        <button
          type='button'
          className={classes.close}
          aria-label='Kapat'
          data-testid='feedback-reply-popup-close'
          onClick={onClose}
        >
          ×
        </button>
        <div className={classes.header}>
          <span className={classes.badge}>{FEEDBACK_REPLY_BADGE}</span>
          {position && position.total > 1 ? (
            <span className={classes.position}>
              {position.index + 1} / {position.total}
            </span>
          ) : null}
        </div>
        <h2 className={classes.title} id='feedback-reply-popup-title' data-testid='feedback-reply-popup-title'>
          {title}
        </h2>
        <div
          className={classes.content}
          data-testid='feedback-reply-popup-content'
          // İçerik kaydedilirken sunucuda temizlenir (p, br, strong, b, em, i, u, h3, h4, ul, ol, li, a).
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <div className={classes.actions}>
          <button
            type='button'
            ref={confirmRef}
            className={classes.confirm}
            data-testid='feedback-reply-popup-confirm'
            onClick={onClose}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
